export default __webpack_public_path__ + "static/media/Group 1873.70179d43.svg";